import { Inject, Injectable } from '@angular/core';
import { CDN_CONFIG } from '../config/tokens.config';
import { GetIconType } from '../constants/get-icon-type.constant';
import { IconType } from '../enum/icon-type.enum';

declare const swal: any;

@Injectable({
    providedIn: 'platform',
})
export class SweetalertService {
    public buttonsDefault = {
        'icon-cancel': {
            className: 'btn-icon-close roblex roblex-close',
            visible: true,
            text: '',
            value: false,
        },
    };

    private messageErrorDefault = {
        title: 'Tittle',
        text: 'Message',
        icon: this.iconType(),
        className: 'sweet-alert-danger',
        buttons: Object.assign(
            {
                confirm: {
                    text: 'Aceptar',
                    visible: true,
                    value: true,
                },
            },
            this.buttonsDefault
        ),
    };

    /**
     * Creates an instance of sweetalert service.
     */
    constructor(@Inject(CDN_CONFIG) public readonly cdnCofing: string) {}

    /**
     * Swals sweetalert service
     * @param params: any
     * @return Promise<any>npm
     */
    swal(params: any): Promise<any> {
        if (params.icon) {
            params.icon = this.iconType(params.icon);
        }
        return swal({ ...params });
    }
    /**
     * Errors sweetalert service
     * @param [title] string | null
     * @param [text] string
     * @returns Promise<any>
     */
    error(title?: string | null, text?: string): Promise<any> {
        return this.swal(
            Object.assign(this.messageErrorDefault, {
                title: title ? title : 'Error',
                text,
            })
        );
    }
    /**
     * Success sweetalert service
     * @param [title]
     * @param [text]
     * @param [iconName]
     * @param [button]
     * @returns success
     */
    success(
        title?: string | null,
        text?: string,
        iconName?: IconType,
        button?: any
    ): Promise<any> {
        return this.swal({
            title: title ? title : 'Exito',
            content: {
                element: 'div',
                attributes: {
                    innerHTML: text,
                },
            },
            icon: !iconName ? IconType.LISTO : iconName,
            className: 'sweet-alert-success',
            buttons: Object.assign(button ?? {}, this.buttonsDefault),
        });
    }
    /**
     * Emails sent
     * @returns Promise<any>
     */
    emailSent(): Promise<any> {
        return this.swal({
            title: 'Revisa tu correo',
            content: {
                element: 'div',
                attributes: {
                    innerHTML:
                        'Ingresa el link que enviamos a tu correo. <br/> Si no lo encuentras revisa en "Spam” ',
                },
            },
            icon: IconType.EMAIL,
            className: 'sweet-alert-success',
            buttons: Object.assign(this.buttonsDefault),
        });
    }
    /**
     * Accounts add
     * @returns Promise<any>
     */
    accountAdd(): Promise<any> {
        return this.swal({
            title: 'Cuenta agregada',
            content: {
                element: 'div',
                attributes: {
                    innerHTML: 'Ya podrás realizar operaciones.',
                },
            },
            icon: IconType.CARD,
            className: 'sweet-alert-success',
            buttons: Object.assign(this.buttonsDefault),
        });
    }
    /**
     * Cards add
     * @returns Promise<any>
     */
    cardAdd(): Promise<any> {
        return this.swal({
            title: 'Tarjeta agregada',
            content: {
                element: 'div',
                attributes: {
                    innerHTML: 'Ya podrás realizar operaciones.',
                },
            },
            icon: IconType.CARD,
            className: 'sweet-alert-success',
            buttons: Object.assign(this.buttonsDefault),
        });
    }
    /**
     * Updates data
     * @returns Promise<any>
     */
    updateData(): Promise<any> {
        return this.swal({
            title: 'Cambio guardado',
            content: {
                element: 'div',
                attributes: {
                    innerHTML: 'Gracias por actualizar los datos.',
                },
            },
            icon: IconType.CARD,
            className: 'sweet-alert-success',
            buttons: Object.assign(this.buttonsDefault),
        });
    }
    /**
     * Unauthorized sweetalert service
     * @returns Promise<any>
     */
    unauthorized(): Promise<any> {
        return this.swal(
            Object.assign(this.messageErrorDefault, {
                title: 'Error',
                text: 'Error de autorización',
            })
        );
    }
    /**
     * Confirms sweetalert service
     * @param [title] string
     * @param [text] string
     * @param [buttonConfirmText] string
     * @param [iconName] y
     * @returns Promise<any>
     */
    confirm(
        title?: string,
        text?: string,
        buttonConfirmText?: string,
        iconName?: IconType
    ): Promise<any> {
        return this.swal(
            Object.assign(this.messageErrorDefault, {
                className: 'sweet-alert-warning',
                title: title ?? 'Title',
                text: null,
                content: {
                    element: 'div',
                    attributes: {
                        className: 'sweet-alert-text-content',
                        innerHTML: text ?? 'Description',
                    },
                },
                icon: iconName,
                buttons: Object.assign(
                    {
                        cancel: {
                            text: 'Regresar',
                            visible: true,
                            value: false,
                        },
                        confirm: {
                            text: buttonConfirmText ?? 'Aceptar',
                            visible: true,
                            value: true,
                        },
                    },
                    this.buttonsDefault
                ),
            })
        );
    }
    /**
     * Icons type
     * @param [iconName] IconType
     * @returns string
     */
    private iconType(iconName?: IconType): string {
        return `${this.cdnCofing}/${GetIconType(iconName)}`;
    }
}
